import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'

interface UseRemoveTopicOptions {
  topicId: number | null
  config?: SWRMutationConfiguration<void, Error, string, undefined>
}

export const useRemoveTopic = ({ topicId, config }: UseRemoveTopicOptions) => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.delete, undefined, void>({
    method: RequestMethodsEnum.delete,
    badRequestHandler: () => {},
    notFoundResponseHandler: () => {},
  })

  return useSWRMutation(
    topicId ? `/api/community/topic/${topicId}` : null,
    adaptFetcherToSWRMutationFn<void, undefined>(fetcher),
    config,
  )
}
